<template>
  <v-layout right>
    <v-dialog v-model="dialog" persistent max-width="500px">
      <v-btn slot="activator" :title="activator.title" :class="activator.className" :color="activator.color">
        <v-icon class="btn-toggle">{{activator.icon}}</v-icon>
      </v-btn>
      <v-card>
        <v-card-title class="text-xs-center headline white-underline elevation-5 grey darken-1"><span
          class="flex xs12 ">{{title}}</span></v-card-title>
        <v-card-text><span v-html="msg"></span> </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" flat @click.native="success = false; dialog=false">{{cancelBtn}}</v-btn>
          <v-btn color="red darken-1" class="text-shadow-15" flat
                 @click="confirmAction">{{confirmBtn}}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>
<script>
  export default{
    props: ['cancelBtn', 'confirmBtn', 'msg', 'successMsg', 'title', 'activator'],
    name: 'confirm-modal',
    data () {
      return {
        dialog: false,
        success: this.successMsg
      }
    },
    methods: {
      confirmAction () {
        this.success = true
        this.dialog = false
        this.$emit('delete')
      }
    }
  }
</script>
<style>
  .text-shadow-15 {
    text-shadow: 1px 1px 2px black;
  }
</style>
